var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.5195L17.1195 25.497L31.5675 11.187C32.1345 10.62 32.4465 9.86698 32.4465 9.06598C32.4465 8.26498 32.1345 7.51198 31.5675 6.94498L29.1885 4.56598C28.0545 3.43198 26.076 3.43798 24.951 4.56148L10.5 18.8745V25.5195ZM27.0675 6.68698L29.451 9.06148L27.0555 11.4345L24.6765 9.05698L27.0675 6.68698ZM13.5 20.1255L22.545 11.166L24.924 13.545L15.8805 22.5015L13.5 22.509V20.1255Z",
    fill: "#5B58E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 31.5H28.5C30.1545 31.5 31.5 30.1545 31.5 28.5V15.498L28.5 18.498V28.5H12.237C12.198 28.5 12.1575 28.515 12.1185 28.515C12.069 28.515 12.0195 28.5015 11.9685 28.5H7.5V7.5H17.7705L20.7705 4.5H7.5C5.8455 4.5 4.5 5.8455 4.5 7.5V28.5C4.5 30.1545 5.8455 31.5 7.5 31.5Z",
    fill: "#5B58E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.79a3fcdfb60236ab8736e0947f0d0900.svg";
export { ForwardRef as ReactComponent };